/*
 * � 2020 Microsoft. All rights reserved.
 */

define('SolitaireShared/SpiderLogic/ChallengeAuthorities/BuildStacksDailySpiderAuthority',[
    'SolitaireShared/SpiderLogic/SpiderAuthority',
    'SolitaireShared/SpiderLogic/IDailySpiderAuthority',
    'SolitaireShared/CardLogic/IDailyAuthority',
    'SolitaireShared/CardLogic/ChallengeConstants'
], function (SpiderAuthority, IDailySpiderAuthority, IDailyAuthority, ChallengeConstants) {
    "use strict";

    var BuildStacksDailySpiderAuthority = function (param) {
        this.initBuildStacksDailySpiderAuthority(param);
    };

    BuildStacksDailySpiderAuthority.constructor = BuildStacksDailySpiderAuthority;
    BuildStacksDailySpiderAuthority.prototype = Object.create(IDailySpiderAuthority.prototype);

    /// <summary>
    /// Constructs a daily challenge authority which implements the win condition "Achieve a score of x"
    /// </summary>
    /// <param name="param">Score which must be obtained</param>
    BuildStacksDailySpiderAuthority.prototype.initBuildStacksDailySpiderAuthority = function (param) {
        IDailySpiderAuthority.call(this);

        if (param != null && param[ChallengeConstants.KeyStacksRequired])
            this.StacksRequired = parseInt(param[ChallengeConstants.KeyStacksRequired]);
        else throw "Invalid parameter passed in creating Daily Challenge";

        this.ChallengeType = IDailyAuthority.ChallengeType.BuildStacks;
    };

    BuildStacksDailySpiderAuthority.prototype.IsGameWon = function ()
    {
        return (!this.CardSupply.WaitingForAnimation) && this.GetCompletedStacks() >= this.StacksRequired;
    };

    return BuildStacksDailySpiderAuthority;

});
